module.exports = __webpack_public_path__ + "img/bjscagzc_position_img.9bbbecac.png";